export type ThemeAccent = 'green' | 'blue' | 'gold' | 'rose' | 'lavender' | 'coral';

export interface ThemeAccentTokens {
  primary: string;
  primaryLight: string;
  primaryDark: string;
  primaryHover: string;
  onPrimary: string;
}

export const THEME_ACCENT_TOKENS: Record<
  ThemeAccent,
  {
    label: string;
    light: ThemeAccentTokens;
    dark: ThemeAccentTokens;
  }
> = {
  green: {
    label: 'Green',
    light: {
      primary: '#00875A',
      primaryLight: '#10B981',
      primaryDark: '#006644',
      primaryHover: '#006644',
      onPrimary: '#FFFFFF',
    },
    dark: {
      primary: '#2BA687',
      primaryLight: '#46C0A2',
      primaryDark: '#1F8067',
      primaryHover: '#249679',
      onPrimary: '#06231B',
    },
  },
  blue: {
    label: 'Blue',
    light: {
      primary: '#0066CC',
      primaryLight: '#3B9EFF',
      primaryDark: '#00529F',
      primaryHover: '#00529F',
      onPrimary: '#FFFFFF',
    },
    dark: {
      primary: '#3B9EFF',
      primaryLight: '#6FB8FF',
      primaryDark: '#2A7FD6',
      primaryHover: '#2A7FD6',
      onPrimary: '#04213B',
    },
  },
  gold: {
    label: 'Gold',
    light: {
      primary: '#B8860B',
      primaryLight: '#F5C842',
      primaryDark: '#946C00',
      primaryHover: '#946C00',
      onPrimary: '#1A1300',
    },
    dark: {
      primary: '#E8B931',
      primaryLight: '#F5C842',
      primaryDark: '#BE9213',
      primaryHover: '#BE9213',
      onPrimary: '#1A1300',
    },
  },
  rose: {
    label: 'Rose',
    light: {
      primary: '#E91E63',
      primaryLight: '#F06292',
      primaryDark: '#C2185B',
      primaryHover: '#C2185B',
      onPrimary: '#120006',
    },
    dark: {
      primary: '#F0588A',
      primaryLight: '#F58FB0',
      primaryDark: '#D63B6E',
      primaryHover: '#D63B6E',
      onPrimary: '#2A0A16',
    },
  },
  lavender: {
    label: 'Lavender',
    light: {
      primary: '#7C4DFF',
      primaryLight: '#B388FF',
      primaryDark: '#6536E0',
      primaryHover: '#6536E0',
      onPrimary: '#FFFFFF',
    },
    dark: {
      primary: '#A88BFF',
      primaryLight: '#C4ABFF',
      primaryDark: '#8A66F0',
      primaryHover: '#8A66F0',
      onPrimary: '#150A2E',
    },
  },
  coral: {
    label: 'Coral',
    light: {
      primary: '#F1543F',
      primaryLight: '#FF9999',
      primaryDark: '#C73B2A',
      primaryHover: '#C73B2A',
      onPrimary: '#2A0A06',
    },
    dark: {
      primary: '#FF7A66',
      primaryLight: '#FFA391',
      primaryDark: '#E85A45',
      primaryHover: '#E85A45',
      onPrimary: '#2A0A06',
    },
  },
};
